import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo } from "react";

import colors from "app/colors";
import { TranslateIcon } from "modules/icons";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import useMessageThreadTranslation from "modules/hooks/use-message-thread-translation";
import { useAuth } from "modules/providers/auth-provider";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const MessagePopoverToggleTranslationButton: React.FC<IProps> = ({
  messageThread,
  message,
}) => {
  const { me } = useAuth();
  const {
    isMessageThreadTranslated,
    isViewingTranslatedMessage,
    toggleViewOriginalMessage,
    originalMessageLanguage,
  } = useMessageThreadTranslation(message, messageThread);

  if (me?.id === message.createdUserId) return null;

  if (!isMessageThreadTranslated) return null;

  if (isViewingTranslatedMessage) {
    return (
      <Button variant="link" onClick={toggleViewOriginalMessage}>
        <HStack spacing={2}>
          <TranslateIcon boxSize={5} fill={colors.blue} />
          <Text fontSize={14} color={colors.blackSecondary}>
            {originalMessageLanguage
              ? `View Original (${originalMessageLanguage})`
              : "View Original"}
          </Text>
        </HStack>
      </Button>
    );
  }

  return (
    <Button variant="link" onClick={toggleViewOriginalMessage}>
      <HStack spacing={2}>
        <TranslateIcon boxSize={5} fill={colors.blue} />
        <Text fontSize={14} color={colors.blackSecondary}>
          View Translation
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverToggleTranslationButton);
